module.exports = __webpack_public_path__ + "static/media/food.cfc792fd.svg";